// Enriched profile content — VERBATIM from spec. Never modify.
export const PHILOSOPHER_PROFILES = {
  aurelius: {
    movement: "Stoicism",
    view: `"Life is a brief assignment. You don't control events — only your judgment of them. Character is built in private, one ordinary day at a time."`,
    strengths: [
      "Self-command (you don't outsource your mood to circumstances)",
      "Quiet endurance (you carry weight without announcing it)",
      "Duty (you show up even when no one is watching)",
    ],
    move: `You are the person others secretly rely on when things fall apart. You process storms internally and present calm externally — which is why people rarely know how much you actually carry.`,
  },
  nietzsche: {
    movement: "Existentialism (precursor)",
    view: `"Life owes you nothing and that's the good news. Suffering is raw material. The goal is not comfort — it is to become who you are, at full intensity."`,
    strengths: [
      "Creative force (you generate ideas others are afraid to think)",
      "Defiance (pressure to conform slides off you)",
      "Hunger (you want more from life than most people dare to)",
    ],
    move: `You feel like an outsider even in rooms you dominate. Mediocrity physically bothers you. You'd rather burn bright and be misunderstood than be comfortable and invisible.`,
  },
  socrates: {
    movement: "Classical Greek philosophy",
    view: `"Wisdom begins with admitting how little you know. An unexamined life runs on autopilot — and autopilot is how most people waste theirs."`,
    strengths: [
      "Relentless questioning (you spot the assumption everyone else missed)",
      "Intellectual honesty (you'd rather be corrected than comfortable)",
      "Composure (irony is your armor)",
    ],
    move: `You can't help poking at what others take for granted. It makes you the most interesting person in the conversation — and occasionally the most annoying. You take that trade.`,
  },
  epicurus: {
    movement: "Epicureanism",
    view: `"Happiness is not intensity, it is absence of torment. Good friends, simple pleasures, freedom from fear — everything else is noise sold to you as necessity."`,
    strengths: [
      "Contentment (you know when enough is enough — rarest skill there is)",
      "Warmth (people relax around you)",
      "Clarity about what matters (you don't chase prizes you don't actually want)",
    ],
    move: `While others sprint on treadmills of ambition, you've quietly stepped off. Your life is curated, not accumulated. People call it modest; you call it solved.`,
  },
  beauvoir: {
    movement: "Existentialism",
    view: `"You are not born who you are — you become it, choice by choice. Freedom is heavy, and taking it seriously is the whole point. Yours, and everyone else's."`,
    strengths: [
      "Independence of mind (no script survives contact with you)",
      "Moral courage (you defend your positions in hostile rooms)",
      "Range (intellect and passion, analysis and engagement)",
    ],
    move: `You audit every expectation before accepting it. People who want you to fit a mold leave disappointed. Your life is a project you are writing yourself, and it shows.`,
  },
  diogenes: {
    movement: "Cynicism",
    view: `"Almost everything people chase — status, approval, possessions — is a cage they built themselves. Freedom is needing nothing and fearing no one's opinion."`,
    strengths: [
      "Unshakeable (mockery and hardship bounce off you)",
      "Radical honesty (you say what everyone thinks and no one dares)",
      "Freedom (your needs are so few that no one can leverage you)",
    ],
    move: `Social games look absurd to you, so you don't play them. This costs you polite society's approval and buys you something better: nobody owns you.`,
  },
  confucius: {
    movement: "Confucianism",
    view: `"Character is a daily practice, not a personality trait. Get the small rituals right — how you greet, work, keep promises — and the large life takes care of itself."`,
    strengths: [
      "Reliability (your word is infrastructure people build on)",
      "Respect (you honor people, traditions, and craft)",
      "Steady improvement (slow doesn't scare you; stopping does)",
    ],
    move: `You are the keel of every group you belong to. Others make noise; you make things hold together. Your influence is quiet, cumulative, and much larger than you think.`,
  },
  arendt: {
    movement: "Political philosophy (20th century)",
    view: `"Evil is mostly thoughtlessness — people following scripts without judging them. The most important act in any life is to think for yourself, especially when it costs you."`,
    strengths: [
      "Independent judgment (crowds don't get a vote in your conclusions)",
      "Courage under pressure (you say the unpopular true thing)",
      "Depth (you refuse easy answers on principle)",
    ],
    move: `You watch groups agree too quickly and feel the itch to dissent. Belonging matters less to you than being right with yourself. It's lonely sometimes — and non-negotiable.`,
  },
};
